import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import observeDomCondition from 'commons/observeDomCondition';
import refreshFinancingContent from 'commons/refreshFinancingContent';
import useAffirmScript, { AFFIRM_LOAD_STRATEGY } from 'hooks/useAffirmScript';

// The Affirm script injects link elements that show the Affirm modal when
// clicked. The default Affirm links include extra information that is not
// needed in the Consumer app, so we normally hide the default Affirm link and
// use a custom button to trigger the Affirm modal instead.

// A ref to the wrapper element where the default link is injected should be
// passed into this hook.
const AFFIRM_OBSERVER_TIMEOUT_MS = 250 * 80;
const getAffirmRefreshObserverTargets = defaultLinkWrapperRef => {
  const targets = [document.head, document.body];
  if (defaultLinkWrapperRef?.current?.nodeType === Node.ELEMENT_NODE) {
    targets.push(defaultLinkWrapperRef.current);
  }
  return targets;
};
const useAffirmRefreshHTML = (defaultLinkWrapperRef, t0) => {
  const $ = _c(11);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    deferLoad: t2,
    eagerLearnMore: t3
  } = t1;
  const deferLoad = t2 === undefined ? false : t2;
  const eagerLearnMore = t3 === undefined ? false : t3;
  const [isDefaultLinkLoaded, setIsDefaultLinkLoaded] = useState(eagerLearnMore);
  const loadStrategy = deferLoad ? AFFIRM_LOAD_STRATEGY.IDLE_AFTER_LCP : AFFIRM_LOAD_STRATEGY.IMMEDIATE;
  let t4;
  if ($[2] !== loadStrategy) {
    t4 = {
      onLoad: refreshFinancingContent,
      loadStrategy
    };
    $[2] = loadStrategy;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useAffirmScript(t4);
  let t5;
  let t6;
  if ($[4] !== defaultLinkWrapperRef) {
    t5 = () => {
      if (!defaultLinkWrapperRef) {
        return _temp;
      }
      return observeDomCondition({
        condition: () => !!(window?.affirm?.ui?.ready && window?.affirm?.ui?.refresh && defaultLinkWrapperRef?.current),
        callback: refreshFinancingContent,
        getTargets: () => getAffirmRefreshObserverTargets(defaultLinkWrapperRef),
        timeout: AFFIRM_OBSERVER_TIMEOUT_MS
      });
    };
    t6 = [defaultLinkWrapperRef];
    $[4] = defaultLinkWrapperRef;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[7] !== defaultLinkWrapperRef || $[8] !== eagerLearnMore) {
    t7 = () => {
      if (!defaultLinkWrapperRef || eagerLearnMore) {
        return _temp2;
      }
      return observeDomCondition({
        condition: () => {
          const affirmWrapper = defaultLinkWrapperRef?.current;
          const affirmLinkOrButton = affirmWrapper?.querySelector?.("a,button");
          return !!affirmLinkOrButton;
        },
        callback: () => {
          setIsDefaultLinkLoaded?.(true);
        },
        getTarget: () => defaultLinkWrapperRef?.current ?? document.body,
        timeout: AFFIRM_OBSERVER_TIMEOUT_MS
      });
    };
    t8 = [defaultLinkWrapperRef, eagerLearnMore];
    $[7] = defaultLinkWrapperRef;
    $[8] = eagerLearnMore;
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  useEffect(t7, t8);
  return isDefaultLinkLoaded;
};
export default useAffirmRefreshHTML;
function _temp() {}
function _temp2() {}